import { constant } from './constant.js';
export const clonedConstant = constant;
